module.exports = __webpack_public_path__ + "static/media/lbcj1.cc680671.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/lbcj1.png
// module id = 557
// module chunks = 0